/**
 * API client for project management endpoints.
 * Routes: /api/mgmt/projects
 */

import { apiFetch } from './client';

export interface Project {
  projectId: string;
  name: string;
  description: string;
  teamId?: string;
  owner: string;
  enabled: boolean;
  maxBudget?: number;
  tpmLimit?: number;
  rpmLimit?: number;
  allowedCidrs?: string[];
  models?: string[];
  keyCount?: number;
  spend?: number;
  metadata?: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;
}

export interface CreateProjectData {
  projectId: string;
  name: string;
  description: string;
  teamId?: string;
  owner: string;
  maxBudget?: number;
  tpmLimit?: number;
  rpmLimit?: number;
  allowedCidrs?: string[];
  models?: string[];
}

export interface UpdateProjectData {
  name?: string;
  description?: string;
  teamId?: string;
  owner?: string;
  enabled?: boolean;
  maxBudget?: number;
  tpmLimit?: number;
  rpmLimit?: number;
  allowedCidrs?: string[];
  models?: string[];
}

export async function listProjects(token: string): Promise<Project[]> {
  const data = await apiFetch<{ projects: Project[] }>('/api/mgmt/projects', token);
  return Array.isArray(data) ? data : (data.projects ?? []);
}

export async function getProject(id: string, token: string): Promise<Project> {
  const data = await apiFetch<{ project: Project }>(`/api/mgmt/projects/${encodeURIComponent(id)}`, token);
  return data.project ?? data as unknown as Project;
}

export async function createProject(data: CreateProjectData, token: string): Promise<Project> {
  const resp = await apiFetch<{ project: Project }>('/api/mgmt/projects', token, {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return resp.project ?? resp as unknown as Project;
}

export async function updateProject(
  id: string,
  data: UpdateProjectData,
  token: string,
): Promise<Project> {
  const resp = await apiFetch<{ project: Project }>(`/api/mgmt/projects/${encodeURIComponent(id)}`, token, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
  return resp.project ?? resp as unknown as Project;
}
